const WIDTHS = ['38%', '14%', '12%', '18%', '10%'] as const;

export function TableSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div className="skeleton-list" role="status" aria-live="polite">
      <span className="visually-hidden">Загружаем список</span>
      {Array.from({ length: rows }, (_, rowIndex) => (
        <div className="skeleton-row" key={rowIndex} aria-hidden="true">
          {WIDTHS.map((width) => (
            <span className="skeleton" key={width} style={{ width }} />
          ))}
        </div>
      ))}
    </div>
  );
}
